// Render input to enter a vehicle type for a dispatch schedule
import { useEffect, useMemo } from 'react';

import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';

import { sample } from 'lodash';

import { commandAlkonVehicleTypeNames } from '@isd/lib/firebase/db/@types/commandAlkonTypes';

import { DispatchScheduleFormContextData } from '@/components/DispatchSchedule/DispatchScheduleForm';

const DATALIST_ID = 'vehicle-type-suggestions';

/** Free-text input for vehicle type with suggested values from Command Alkon. */
export default function VehicleTypeInput() {
  const { register, watch, setValue } =
    useFormContext<DispatchScheduleFormContextData>();
  const isEnabled = watch('isVehicleTypeEnabled');
  const placeholder = useMemo(
    () => `e.g. ${sample(commandAlkonVehicleTypeNames)}`,
    []
  );

  useEffect(() => {
    if (!isEnabled) {
      setValue('vehicleType', null);
    }
  }, [isEnabled]);

  return (
    <div className="flex flex-col gap-2 md:flex-row md:gap-0">
      <label className="clickable label basis-4/12 justify-start">
        <input
          type="checkbox"
          className="checkbox-primary checkbox border-base-300 mr-2"
          {...register('isVehicleTypeEnabled')}
        />
        <span className="label-text">Vehicle Type</span>
      </label>
      <div className={clsx('w-full basis-8/12', !isEnabled && 'invisible')}>
        <input
          {...register('vehicleType', {
            required: isEnabled,
            onChange: (e) => {
              e.target.value = e.target.value.toUpperCase();
            },
          })}
          type="text"
          list={DATALIST_ID}
          placeholder={placeholder}
          className="input w-full"
        />
        <datalist id={DATALIST_ID}>
          {commandAlkonVehicleTypeNames.map((name) => (
            <option key={name} value={name} />
          ))}
        </datalist>
      </div>
    </div>
  );
}
